export const mutations = {
  /**
   * set dashboard and widgets
   */
  setDashboardAndWidgets(state, { dashboardAndWidgets, dashboardUUID }) {
    state.dashboardWidgetsMap[dashboardUUID] = dashboardAndWidgets;
  },

  setCurrentDashboard(state, { currentDashboard }) {
    state.currentDashboard = currentDashboard;
  },

  setCurrentWidgets(state, { currentWidgets }) {
    state.currentWidgets = currentWidgets;
  }
};
